import * as VKID from '@vkid/sdk';
import cn from 'classnames';
import { useLayoutEffect } from 'react';

import { HOST_DOMAIN, HOST_PROTOCOL } from '@webapp/common/conf';
import { isBrowser } from '@webapp/common/lib/const';

import { selectDomain, selectInfo, selectToken } from '@webapp/survey/src/machine/selectors';
import { useStateSelector } from '@webapp/survey/src/machine/use-state-selector';
import { useStore } from '@webapp/survey/src/store';

import css from './auth.css';

declare global {
    // eslint-disable-next-line no-unused-vars
    interface Window {
        vkAsyncInit: () => void;
        VK: {
            init: ({ apiId, onlyWidgets }: { apiId: number; onlyWidgets: boolean }) => void;
            Widgets: {
                Auth: (id: string, params: OnAuthParams) => void;
            };
        };
    }
}

export interface OnAuthParams {
    onAuth: (data: any) => void;
    width: string | number;
    height: string | number;
}

export const VkAuth: VFC = () => {
    const {
        design: {
            fonts: { buttonColor },
        },
    } = useStateSelector(selectInfo);
    const domain = useStateSelector(selectDomain);
    const token = useStateSelector(selectToken);
    const { send } = useStore();
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const domReady = Boolean(isBrowser && window.document && window.document.createElement);
    const onSuccessHandler = ({ access_token }) => {
        VKID.Auth.userInfo(access_token).then(({ user: { first_name, last_name, avatar: photo, user_id: uid } }) => {
            send({
                type: 'AUTH_CHECK_VK',
                authdata: JSON.stringify({ first_name, last_name, photo, uid }),
                domain,
                token,
            });
        });
    };

    useLayoutEffect(() => {
        if (domReady) {
            VKID.Config.init({
                app: 54295707,
                redirectUrl: `${HOST_PROTOCOL}survey.${HOST_DOMAIN}?redirect_to=${window.location.origin}`,
                responseMode: VKID.ConfigResponseMode.Callback,
                source: VKID.ConfigSource.LOWCODE,
                scope: '', // Заполните нужными доступами по необходимости
            });

            const oneTap = new VKID.OAuthList();
            const container = document.getElementById('vk_auth');
            oneTap
                .render({ container, oauthList: [VKID.OAuthName.VK] })
                .on(VKID.OAuthListInternalEvents.LOGIN_SUCCESS, function (payload) {
                    const code = payload.code;
                    const deviceId = payload.device_id;

                    VKID.Auth.exchangeCode(code, deviceId).then(onSuccessHandler);
                });
        }
    }, [domReady]);

    return (
        <div className={cn(css.box, css.vk_auth)} style={{ borderColor: buttonColor }}>
            <div id='vk_auth' />
        </div>
    );
};
VkAuth.displayName = 'VkAuth';
